import { render, staticRenderFns } from "./RoleMethodAuth.vue?vue&type=template&id=07fccfb4&scoped=true&"
import script from "./RoleMethodAuth.vue?vue&type=script&lang=js&"
export * from "./RoleMethodAuth.vue?vue&type=script&lang=js&"
import style0 from "./RoleMethodAuth.vue?vue&type=style&index=0&id=07fccfb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fccfb4",
  null
  
)

export default component.exports